import { Box, Button, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'
import AddBoxIcon from '@mui/icons-material/AddBox';
import AddLinkIcon from '@mui/icons-material/AddLink';
import ModalCustom from '../../../../components/modal/modalCustomCms';
import StateComponents from '../../../../components/state-component/StateComponents';
import { formatFileSize, isVideoUrl, MEDIA_ENUM } from '../../../../utils/app.utils';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import { MediaApi } from '../../../../api/media-file/MediaFile.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import moment from 'moment';

type Props = {
    vdo_data: { id_media_file: number | null, gallery_link: string, created_date?: string, media_file_name?: string, media_file_path?: string, media_file_size?: string }[];
    heading?: string;
    required?: boolean;
    onLinkChange?: (link: string) => void;
    onUploadChange?: (data: { id_media_file: number, media_file_path: string, media_file_name: string }) => void;
    handleDeleteByIndex?: (index: number, objData?: any) => void;
    onVdoUploadOtherApi?: (file: File) => void;
    hidden_link?: boolean;
    disabled?: boolean;
}

const VdoUploadContent: React.FC<Props> = ({ onVdoUploadOtherApi, hidden_link, disabled, onUploadChange, vdo_data, heading = "ไฟล์วีดีโอ", handleDeleteByIndex, required, onLinkChange }: Props) => {
    const base_url = process.env.REACT_APP_FILE_BASE_API_URL!
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [link, set_link] = useState<string>("");
    const [is_view, set_is_view] = useState<boolean>(false);


    const handleCloseModal = () => {
        setShowModal(false);
        set_link("");
        set_is_view(false);
    }

    const handleSubmitLink = () => {
        onLinkChange?.(link);
        handleCloseModal();
    }

    const is_not_valid = isVideoUrl(link);


    const handleUploadFileVdoData = (file: File) => {
        onVdoUploadOtherApi?.(file);
    }
    const handleCreateFileMedia = async (file: File) => {
        const formData = new FormData();
        formData.append("files", file);
        dispatch(setLoading());
        await MediaApi.createFile(MEDIA_ENUM.LOCAL_FILE, formData).then((res) => {
            if (res.status < 300) {
                const data: any[] = res.data?.data;
                if (data?.length > 0) {
                    const file_data = data[0];
                    onUploadChange?.({
                        id_media_file: file_data?.id_media_file,
                        media_file_name: file_data?.media_file_name,
                        media_file_path: file_data?.media_file_path
                    })
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    return (
        <>
            <Box className="w-full my-4 shadow-lg rounded-xl p-4 h-full">
                <Box className="flex gap-1 justify-start items-center">
                    <Box component="label" htmlFor="upload_vdo">
                        <Tooltip title="เพิ่มวีดีโอ" arrow>
                            <Button
                                disabled={disabled}
                                component="span"
                                sx={{ color: "#DDE1EB", p: 1, minWidth: "fit-content" }}
                            >
                                <AddBoxIcon />
                            </Button>
                        </Tooltip>
                        {!disabled && (
                            <input
                                id="upload_vdo"
                                type="file"
                                accept="video/*"
                                hidden
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file && onVdoUploadOtherApi) {
                                        handleUploadFileVdoData(file);
                                    }
                                    else if (file) {
                                        handleCreateFileMedia(file)
                                        // console.log('Selected video file:', file);
                                    } else {
                                        return false
                                    }
                                }}
                            />
                        )}
                    </Box>
                    {!hidden_link && (
                        <Tooltip title="เพิ่มลิงค์" arrow>
                            <Button disabled={disabled} onClick={() => setShowModal(true)} sx={{ color: "#DDE1EB", p: 1, minWidth: "fit-content" }}><AddLinkIcon /></Button>
                        </Tooltip>
                    )}
                    <div className='flex gap-1 justify-start items-center'>
                        <Typography variant='h6'>
                            {heading}
                        </Typography>
                        {required && (
                            <Typography color={"red"}>*</Typography>
                        )}
                    </div>
                </Box >
                <Box>
                    {vdo_data?.map((list, index) => {
                        return (
                            <Box component={"article"} className="p-6 flex justify-between items-center px-4">
                                <Box>
                                    <Typography>{list.gallery_link || list?.media_file_name || "-"}</Typography>
                                    <Box className="flex gap-2 justify-start items-center">
                                        {list?.media_file_size && (
                                            <Typography>
                                                {formatFileSize(Number(list?.media_file_size || 0))}
                                            </Typography>
                                        )}
                                        <Typography>
                                            {list?.created_date ? new Date(list?.created_date).toLocaleString('th-Th') : new Date().toLocaleString('th-Th')}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box>
                                    <OptionsButtonCustom
                                        enableView
                                        enableDelete
                                        onDeleteClick={() => handleDeleteByIndex?.(index, list)}
                                        onViewClick={() => {
                                            if (list?.gallery_link) {
                                                window.open(list?.gallery_link, '_blank');
                                                // set_link(list?.gallery_link);
                                                // setShowModal(true);
                                                // set_is_view(true);
                                            } else {
                                                window.open(`${base_url}/${list?.media_file_path}${list?.media_file_name}`)
                                            }
                                        }}
                                    />
                                </Box>
                            </Box>
                        )
                    })}
                </Box>
            </Box >


            <ModalCustom
                handleClose={handleCloseModal}
                onClick={handleSubmitLink}
                open={showModal}
                title='เพิ่มลิ้งค์'
                subTitle='ระบุข้อมูลให้ครบถ้วน'
                hintSubmitButton={is_view}
                disabledSubmitButton={!link || !is_not_valid}
                maxWidth='md'
                form={
                    <Box className="w-full">
                        <StateComponents
                            sxContainer={{
                                my: 2
                            }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12
                                    },
                                    fieldProps: {
                                        placeholder: "ระบุ link",
                                        value: link,
                                        disabled: is_view,
                                        helperText: link ? !is_not_valid ? "รูปแบบ URL ไม่ถูกต้อง" : undefined : undefined,
                                        onChange: (e) => set_link(e.target.value),
                                    }
                                }
                            ]}
                        />
                    </Box>
                }
            />
        </>
    )
}

export default VdoUploadContent